/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Cell, TableCommonProps } from "react-table";
import { theme, SVGIcon } from "@nordcloud/gnui";

export function TableExpander() {
  return [
    {
      id: "expander",
      Header: ({
        getToggleAllRowsExpandedProps,
      }: {
        getToggleAllRowsExpandedProps: () => TableCommonProps;
      }) => <span {...getToggleAllRowsExpandedProps()} />,
      Cell: ({ row }: Cell) => TableExpanderTemplate({ row }),
      width: "1%",
    },
  ];
}

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  row: any;
  raw?: boolean;
};

export function TableExpanderTemplate({ row, raw = false }: Props) {
  const shiftRatio = raw ? 1.65 : 1.25;
  const props = row.getToggleRowExpandedProps();

  return (
    <If condition={row.canExpand}>
      <Then>
        <div {...props} data-testid="row-expander">
          <SVGIcon
            name={row.isExpanded ? "chevronDown" : "chevronRight"}
            css={{
              width: theme.spacing.spacing04,
              height: theme.spacing.spacing04,
              cursor: "pointer",
              paddingLeft: `${row.depth * shiftRatio}rem`,
              marginRight: `${raw ? theme.spacing.spacing04 : 0}`,
            }}
          />
        </div>
      </Then>
      <Else>
        <div
          css={{
            display: "flex",
            justifyContent: "left",
            paddingLeft: `${row.depth * shiftRatio}rem`,
            marginRight: `${raw ? theme.spacing.spacing04 : 0}`,
          }}
        >
          <SVGIcon
            name="minus"
            css={{
              width: theme.spacing.spacing04,
              height: theme.spacing.spacing04,
              paddingLeft: "2px",
            }}
          />
        </div>
      </Else>
    </If>
  );
}
